/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { PaymentApiConfiguration } from '../payment-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Notify200ResponseDtoDto } from '../models/notify-200-response-dto-dto';
import { NotifyRequestDtoDto } from '../models/notify-request-dto-dto';


/**
 * the PmaPaymentNotificationCommand API
 */
@Injectable({
  providedIn: 'root',
})
export class PmaPaymentNotificationCommandService extends BaseService {
  constructor(
    config: PaymentApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation notify
   */
  static readonly NotifyPath = '/system/payment';

  /**
   * Test method - to notify about payment execution.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notify()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notify$Response(params: {
    body: NotifyRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Notify200ResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, PmaPaymentNotificationCommandService.NotifyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Notify200ResponseDtoDto>;
      })
    );
  }

  /**
   * Test method - to notify about payment execution.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notify$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notify(params: {
    body: NotifyRequestDtoDto
  },
  context?: HttpContext

): Observable<Notify200ResponseDtoDto> {

    return this.notify$Response(params,context).pipe(
      map((r: StrictHttpResponse<Notify200ResponseDtoDto>) => r.body as Notify200ResponseDtoDto)
    );
  }

}
